import template from './AxSurveyFieldHtml.html';

function AxSurveyFieldHtml() {

  return {
    restrict: 'E',
    scope: {
      // We don't want long names :)
      axC: '=axControl' // Bi-directional binding - to można zapodawac do kązdej dyrektywy - definiuje jak są ich wartości bindowane
    },
    link: link,
    template,
    controllerAs: 'vm',
    bindToController: true,
    controller: ['Helpers', controller]
  }
}

function controller(helpers) {

  var vm = this;
  helpers.initField(vm);

}

function link($scope, $element, $attrs, $ctrl) {
}

export { AxSurveyFieldHtml };
